import { render, staticRenderFns } from "./DataView3d.vue?vue&type=template&id=a209c9ce"
import script from "./DataView3d.vue?vue&type=script&lang=js"
export * from "./DataView3d.vue?vue&type=script&lang=js"
import style0 from "./DataView3d.vue?vue&type=style&index=0&id=a209c9ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports